﻿import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../auth/auth.service';
import {Observable} from 'rxjs/Observable';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  model: any = {};
  loading = false;
  returnUrl: string;
  error: string;
  //BASE_REG_ENDPOINT = "http://api.hvsfinancial.com.loc/api/CoreRegistration/";
  sentForgotPasswordLink: boolean = false;
  public waitingOnData: boolean = false;
  message;
  myForm: FormGroup;
  loaded: Boolean = false;

  public sitePath: string = '';
  public isHVAM: boolean;

  constructor(private fb: FormBuilder,private route: ActivatedRoute, private router: Router, private authService: AuthService, public Global: GlobalService) { 
    this.sitePath = window.location.hostname;
    this.sitePath = this.sitePath.substring(0, this.sitePath.indexOf('.'));
   
    this.isHVAM = (this.sitePath == 'hvam' || this.sitePath == 'hwh') ? true : false;
  }

  ngAfterViewInit() {
    if(this.isHVAM){

      console.log('should not be here');
      let head = document.getElementsByTagName('head')[0];
      let style = document.createElement('link');
      style.rel = 'stylesheet';
      style.href = 'assets/css/hvam/hvam-styling.css';
      head.appendChild(style);
      console.log('style', head);

    }
  }

  ngOnInit() {
    // reset login status
    //this.authService.logout();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    this.myForm = this.fb.group({
      username: ['', [Validators.required,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]], 
      recaptchaReactive: new FormControl(null, Validators.required)
    });

    this.loaded = true;
  }

  onSubmit(form: FormGroup) {
    //console.log("clicked");
   /*  if(form.value.username == null){
      return this.message = "Please enter a valid email address so we can process this request.";
    } */
        
    var body = "{";
    //body += '"Username":' + form.value.UserID + ',';
    body += '"Username":"' + form.value.username + '"';
    body += "}";

    this.Global.post("CoreRegistration/ForgotPassword", body)
    .subscribe(response => { 
        if(response){          
            this.message = "An email was sent to the email address on your account. Please follow the instructions in the email to reset your password.";        
        }else if(!response){
            this.message = "There seemed to be an issue; For security reasons, we did not proceed with the password reset.";
        }else{
            this.message = response; //message from server
        }
    });

}

/*   handleEnter(e) {
    if (e.keyCode == 13) {
      console.log('enter');
      this.onSubmit();
    }
  } */
}
